import { BreadcrumbComponentModule } from "./../_component/breadcrumb/breadcrumb.module";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { HeaderModule } from "../../_component/header/header.module";
import { SharedDirectivesModule } from "../../_directives/shared-directives.module";
import { PaginationClientSideModule } from "../_component/pagination-client-side/pagination-client-side.module";
import { SearchBarModule } from "../_component/search-bar/search-bar.module";
import { BuildingPageRoutingModule } from "./building-routing.module";
import { BuildingViewModule } from "./building-view/building-view.module";
import { BuildingPage } from "./building.page";
import { ListHeaderComponentModule } from "../_component/_structural/list-header/list-header.module";
import { LoadingStiModule } from "src/app/_component/loading-sti/loading-sti.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BuildingPageRoutingModule,
    PaginationClientSideModule,
    BuildingViewModule,
    TranslateModule,
    SharedDirectivesModule,
    SearchBarModule,
    HeaderModule,
    BreadcrumbComponentModule,
    ListHeaderComponentModule,
    LoadingStiModule
  ],
  declarations: [BuildingPage],
})
export class BuildingPageModule {}
